import {
  Card,
  Typography,
  CardContent,
  CardActions,
  Divider,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

export default function DashboardCard(props) {
  const theme = useTheme();
  return (
    <Card className="rootstyle text-center text-white bg-[#ee060b] !rounded-xl [overflow:inherit] h-full ![box-shadow:0rem_0.25rem_0.375rem_-0.0625rem_rgb(0_0_0_/_10%),0rem_0.125rem_0.25rem_-0.0625rem_rgb(0_0_0_/_6%)]">
      <Card className="card-main">
        <Box className="card-box">
          <CardActions>
            <div className="icon-box text-black">
              <Box
                borderRadius="xl"
                display="flex"
                justifyContent="center"
                alignItems="center"

                //  width="4rem"
                // height="4rem"
                // mt={-9}
              >
                {props.children}
              </Box>
            </div>
          </CardActions>
          <CardContent
            className="text-left w-full"
          >
            <Typography variant="p" className="text-[16px]">
              {props.tittle}
            </Typography>
            <Typography variant="h4">{props.total}</Typography>
          </CardContent>
        </Box>
        <Divider />
        {/*<Box p={2} sx={{textAlign: "left"}}>
        <Typography variant="p" ><LocalOfferIcon/> It is a long established fact</Typography>
  </Box>*/}
      </Card>
    </Card>
  );
}
